module.exports = __webpack_public_path__ + "static/img/fish30.d694b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish30.png
// module id = TDsO
// module chunks = 0